// extracted by mini-css-extract-plugin
module.exports = {"btn":"C_r v_sb v_rS h_fq h_fF h_ft h_hg","full":"C_tv h_dq h_dB"};